import { fishingContestSelectionForQuery } from "../../js/fishing-contest/contract.js";
import { normalizeSearchExpression, emptyFishingSelection } from "./core.js";

export function expressionUsesFishingContest(expression) {
  if (!expression || typeof expression !== "object") return false;
  if (expression.type === "term") return expression.term?.kind === "fishing-contest";
  if (expression.type === "container") return expressionUsesFishingContest(expression.expression);
  return Array.isArray(expression.children)
    && expression.children.some(expressionUsesFishingContest);
}

function compileContestNode(node, itemIds) {
  if (node.type === "term") {
    if (node.term.kind !== "fishing-contest") return node;
    return itemIds.length
      ? { ...node, term: { kind: "item-group", itemIds } }
      : emptyFishingSelection(node.negated === true);
  }
  if (node.type === "container") {
    return { ...node, expression: compileContestNode(node.expression, itemIds) };
  }
  return { ...node, children: node.children.map((child) => compileContestNode(child, itemIds)) };
}

// Resolve only at the runtime boundary: saved/editor expressions remain symbolic.
// Unavailable epochs poison the entire query, even beneath OR or NOT. A ready
// empty selection is different: it is false locally and obeys ordinary Boolean
// composition, so NOT contest then matches the fishing universe.
export function resolveFishingContestExpression(expression, selection, nowSeconds) {
  const normalized = normalizeSearchExpression(expression);
  if (!expressionUsesFishingContest(normalized)) return normalized;
  const projection = fishingContestSelectionForQuery(selection, nowSeconds);
  if (!projection) return emptyFishingSelection();
  if (projection.itemIds.some((itemId) => itemId > 2_147_483_647)) {
    throw new RangeError("Fishing contest item ID exceeds the native map contract");
  }
  return compileContestNode(normalized, projection.itemIds);
}
